import React from "react";
import "styled-components/macro";

export interface IconsContainerProps {
  icon?: React.ReactNode;
  height?: number;
  width?: number;
  color?: string;
}
export const IconContainer = ({
  icon,
  height = 52,
  width = 52,
  color = "#e3f8fa",
}: IconsContainerProps) => (
    <div
      css={`
        width: ${width}px;
        height: ${height}px;
        border-radius: 15px;
        background-color: ${color};
        display: flex;
        justify-content: center;
        justify-content: center;
      `}
    >
      <div
        css={`
          margin: auto;
        `}
      >
        {icon}
      </div>
    </div>
  );
